<template>
	<label class="switch-wrap" :class="{ 'is-disabled': disabled }">
		<input
			type="checkbox"
			:checked="value"
			:disabled="disabled"
			@change="$emit('input', $event.target.checked)"
		/>
		<span class="switch-track" :class="[sizeClass, { checked: value, disabled }]">
      <span class="switch-thumb"></span>
    </span>
		<span v-if="label" class="switch-label">{{ label }}</span>
	</label>
</template>

<script>
export default {
	name: 'SwitchToggle',
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value:    { type: Boolean, default: false },
		label:    { type: String,  default: '' },
		size:     { type: String,  default: 'sm' },  // 'sm' | 'md' | 'lg'
		disabled: { type: Boolean, default: false }
	},
	computed: {
		sizeClass() {
			return `size-${this.size}`
		}
	}
}
</script>

<style scoped>
.switch-wrap {
	display: inline-flex; align-items: center;
	gap: 10px; cursor: pointer; user-select: none;
}
.switch-wrap.is-disabled { cursor: not-allowed; }
.switch-wrap input[type="checkbox"] {
	position: absolute; opacity: 0; width: 0; height: 0;
}
.switch-track {
	position: relative; width: 44px; height: 24px;
	border-radius: 999px; background: #d1d5db;
	border: 1px solid #c4c8cd; transition: background .2s, border-color .2s;
}
.switch-track.checked   { background: #1D9E75; border-color: #0F6E56; }
.switch-track.disabled  { opacity: 0.45; pointer-events: none; }
.switch-track.size-sm   { width: 34px; height: 20px; }
.switch-track.size-lg   { width: 54px; height: 30px; }

.switch-thumb {
	position: absolute; top: 3px; left: 3px;
	width: 16px; height: 16px; border-radius: 50%;
	background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,.2);
	transition: left .2s;
}
.switch-track.checked .switch-thumb    { left: calc(100% - 19px); }
.switch-track.size-sm .switch-thumb    { width: 12px; height: 12px; }
.switch-track.size-sm.checked .switch-thumb { left: calc(100% - 15px); }
.switch-track.size-lg .switch-thumb    { width: 22px; height: 22px; }
.switch-track.size-lg.checked .switch-thumb { left: calc(100% - 25px); }

.switch-label { font-size: 14px; }
</style>
